<!--Filter Code  -->
<!-- Start of Quick search common component -->
  <app-quick-search 
    [DefaultFilterArray]="DefaultFilterArray"
    [QuickSearchFilterArray]="quickFilterArray"
    (updateDefaultArray)="updateDefaultArray($event)"
    (clearQuickSearch)="clearQuickSearch($event)">
  </app-quick-search>
<!-- End of Quick search common component -->

<div class="col-lg-12 nopadding">
  <app-filter-panel 
    pageName="CAIS-TID"
    [GridColumns]="GridColumns" 
    [DefaultFilterArray]="DefaultFilterArray"
    (FilterEvent)="FilterApplyFilterEvent($event)"
    >
  </app-filter-panel>
</div>

<!-- Record Type Filter -->
<div class="col-lg-12 noLineHeight nopadding">
  <div class="ui-widget-header-1 nopadding">
    <ul class="nopadding">
      <label for="SUBMITTED">
        <p-button [id]="'SUBMITTED'" type="button" 
          [ngClass]="activeRecordType === 'MASTER' ? 'button btn-xs active-symbol cais-tid-submission-button' : 'button btn-xs non-active-symbol'"
          (click)="getRecordTypeData('MASTER');this.activeRecordType = 'MASTER';">
          SUBMITTED
        </p-button>
      </label>
      <label for="NONSUBMITTED">
        <p-button [id]="'NONSUBMITTED'" type="button" 
          [ngClass]="activeRecordType === 'STAGING' ? 'button btn-xs active-symbol cais-tid-submission-button' : 'button btn-xs non-active-symbol'"
          (click)="getRecordTypeData('STAGING');this.activeRecordType = 'STAGING';">
          NOT SUBMITTED
        </p-button>
      </label>
    </ul>
  </div>
</div>

<!-- Add Button -->
<div class="col-lg-12 nopadding">
  <div class="ui-widget-header-1 nopadding">
    <div class="ui-grid-col-12 btnPanel">
      <label for="TIDGeneratorBtn">
        <button pButton id="TIDGeneratorBtn" type="button" [disabled]="false" label="TID Generator" (click)="caisServiceService.isDisplayTIDGenerator = true;" class="button tid-form-action-button btn-lg tid-form-action-button-label"></button>
      </label>
    </div>
  </div>
</div>

<!-- Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isLoadingResults){
  <div class="example-loading-shade">
    <mat-spinner></mat-spinner>
  </div>
  }
  <p-table 
    alwaysShowPaginator="true" 
    paginatorPosition="both" 
    showCurrentPageReport="true"
    [value]="dataset" 
    [columns]="cols" 
    [resizableColumns]="true" 
    columnResizeMode="expand"
    [totalRecords]="totalRecords" 
    [(selection)]="this.dataService.roeSelectedRecords"
    [paginator]="true"
    selectionMode="single"
    appendTo="body"
    (onPage)="changePage($event)"
    (onSort)="sort($event)" 
    sortMode="multiple"
    [rows]="constantService.DEFAULT_ROWSIZE" 
    [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS"
    [rowsPerPageOptions]="rowsPerPageOptions"  
    [lazy]="true" 
    [scrollable]="true" 
    scrollHeight="60vh"
    styleClass="cais-tid-table"
    #dt>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length" class="text-center">
          {{tbldatamsg}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
        <th id="columns" pResizableColumn [pSortableColumn]="col.field"
          [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
          {{col.header}}
          @if((col.header | lowercase) !== 'action'){
          <p-sortIcon [field]="col.field"></p-sortIcon>
          }
        </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex"
        [ngClass]="(row['rsmsStatus'] | lowercase)== 'u' ? 'ui-widget-updated-row' : (row['rsmsStatus'] | lowercase) == 'd' ? 'ui-widget-deleted-row .ui-chkbox ' : 'ui-widget-NoUpdated-row'">
        @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
        <td class="ui-resizable-column"
          [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay' : ''">
          <!-- set String -->
           @if(!['Foreign TID Country', 'Replacing Foreign TID Country', 'Action'].includes(col.header)){
          <span>
              {{row[col.field]}}
          </span>
          }
          @if(['Foreign TID Country'].includes(col.header)){
          <span>
            {{(row[col.field] ? row['foreignTIDCountry'] : '')}}
          </span>
          }
          @if(['Replacing Foreign TID Country'].includes(col.header)){
            @if(['Replacing Foreign TID Country'].includes(col.header)){
          <span>
            {{(row[col.field] ? row['replacingForeignTIDCountry'] : '')}}
          </span>}
          }
          @if(col.header === 'Action'){
          <span>
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" matTooltipPosition="above"
              appendTo="body" icon="fa fa-xxx fa-eye" (click)="onRowSelect('View',rowIndex,row);"></p-button>
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Edit" matTooltipPosition="above"
              appendTo="body" icon="fa fa-fw fa-edit" (click)="onRowSelect('Edit',rowIndex,row);"></p-button>
          </span>
          }
        </td>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <app-export-to-csv [gridColumns]="GridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
      Total Records: {{dataset.length == 0? 0 : totalRecords}}
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <!-- Page No : {{pageNumber }} -->
      Showing {{dataset.length == 0? 0 : startLimit + 1}} to {{dataset.length
          < rowcount ? dataset.length < startLimit ? endLimit : dataset.length : endLimit}} entries
         </ng-template>
  </p-table>
  <br>
  <br>
</div>

<!-- below code to make common edit screen -->
 @if(openDialog){
<app-add-edit-view-form 
    [screenType]="'CAIS-TID'" 
    (closeDialog)="closeDialog($event)"
    (editScreenRow)="updateScreenRow($event)"  
    [rowData]="rowDataforDialog" 
    [index]="rowIndexForDialog" 
    [actionType]="actionType"
    [editScreenNegotiatedFields]="editScreenNegotiatedFields"
    [viewScreenNegotiatedFields]="viewScreenNegotiatedFields"
    [screenData]="screenDataDetails">
</app-add-edit-view-form>
 }
<!-- TID Generator -->
<app-tid-generator></app-tid-generator>